"use strict";

exports.__esModule = true;
exports.TicketTypeSelector = void 0;
var _react = _interopRequireDefault(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _polished = require("polished");
var _index = require("../../Core/Selector/index");
var _Core = require("../../Core");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var ColorIndicator = _styledComponents["default"].div.withConfig({
  displayName: "TicketTypeSelector__ColorIndicator",
  componentId: "sc-1oa3qn6-0"
})(["background-color:", ";height:15px;width:15px;margin-left:5px;"], function (props) {
  return props.inputColor;
});
function getKey(input) {
  return input.id;
}
function renderItemText(input) {
  return input.value;
}
function renderItemLabel(input) {
  return /*#__PURE__*/_react["default"].createElement(ColorIndicator, {
    inputColor: input.color
  });
}
function itemPredicate(query, type) {
  var q = query.toLowerCase();
  return type.value.toLowerCase().indexOf(q) !== -1;
}

/**
 * Allows a user to select ticket types from a list.
 */
var TicketTypeSelector = exports.TicketTypeSelector = function TicketTypeSelector(props) {
  return /*#__PURE__*/_react["default"].createElement(_Core.Translator, null, function (_ref) {
    var translate = _ref.translate;
    return /*#__PURE__*/_react["default"].createElement(_index.Selector, _extends({
      dataTestId: "TicketTypeSelector",
      placeholder: translate("TicketTypeSelector.placeholder", "Select Types"),
      getKey: getKey,
      renderItemText: renderItemText,
      renderItemLabel: renderItemLabel,
      itemPredicate: itemPredicate,
      getTagProps: function getTagProps(label, index) {
        var selected = props.selected;
        var item = selected[index];
        var backgroundColor = item.color;
        var style = {
          backgroundColor: backgroundColor,
          color: (0, _polished.readableColor)(backgroundColor)
        };
        return {
          style: style
        };
      },
      multiple: true,
      items: props.items,
      width: 275
    }, props));
  });
};